export const DEX = {
  Daimon: 'Daimon',
  Vonder: 'Vonder',
  Foodcourt: 'Foodcourt',
  Baryon: 'Baryon',
}
